<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container class="">
      <nuxt-page />
    </q-page-container>
  </q-layout>
</template>
